import { render } from "./OrderEdit.vue?vue&type=template&id=e8d027f2&ts=true"
import script from "./OrderEdit.vue?vue&type=script&lang=ts"
export * from "./OrderEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__